module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_mapa.e6fbd7ef.png";